import { render } from "./nobind.vue?vue&type=template&id=8a6fcef6&scoped=true"
import script from "./nobind.vue?vue&type=script&lang=js"
export * from "./nobind.vue?vue&type=script&lang=js"

import "./nobind.vue?vue&type=style&index=0&id=8a6fcef6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a6fcef6"]])

export default __exports__